import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"edit\"><defs><style></style></defs><path d=\"M128 896h768v-64H128zm128-192V557.248l224-224L626.752 480l-224 224H256zm352-498.752L754.752 352 672 434.752 525.248 288 608 205.248zm214.624 169.408l.032-.032a32 32 0 000-45.248l-.032-.032-191.968-191.968-.032-.032a32 32 0 00-45.248 0l-.032.032L192 530.752V768h237.248l393.376-393.344z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol